<template>
    <jet-form-section @submitted="createTeam" className="new-repository-box">
        <template #form>
            <div class="box-title">
                <jet-label for="name" value="Repository Name" />
                <jet-input id="name" type="text" class="mt-1 block w-full" v-model="form.name" autofocus  placeholder="Type here" />
                <jet-input-error :message="form.errors.name" class="mt-2" />
            </div>
            <p class="box-text">Please enter the name of the repository for your reference. It could be the name of the team, project or anything.</p>
            <div class="box-title">
                <jet-label for="slug" value="Repository Slug" />
                <jet-input id="slug" type="text" class="mt-1 block w-full" v-model="form.slug" placeholder="Type here" />
                <jet-input-error :message="form.errors.slug" />
            </div>
            <p class="box-text">Repository slug must be unique across the platform and must meet URL requirements. It is case insensitive. Must include only Latin letters, numbers and dashes for better compatibility. Example: acme-web-portal</p>
        </template>

        <template #actions>
            <div class="btn-col btn-padding">
                <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    <span>Create Repository</span>
                </jet-button>
            </div>
        </template>
    </jet-form-section>
</template>

<script>
    import JetButton from '@/Jetstream/Button'
    import JetFormSection from '@/Jetstream/FormSection'
    import JetInput from '@/Jetstream/Input'
    import JetInputError from '@/Jetstream/InputError'
    import JetLabel from '@/Jetstream/Label'

    export default {
        components: {
            JetButton,
            JetFormSection,
            JetInput,
            JetInputError,
            JetLabel,
        },

        data() {
            return {
                form: this.$inertia.form({
                    name: '',
                    slug: ''
                })
            }
        },

        methods: {
            createTeam() {
                this.form.post(route('teams.store'), {
                    errorBag: 'createTeam',
                    preserveScroll: true
                });
            },
        },
    }
</script>
